<template>
  <div>
    <Header activePage="Hear our Stories" />
    <div id="stories">
      <div>
       <iframe
         width="100%"
         height="400px"
         src="https://www.youtube.com/embed/Nta4HfSFY48"
         frameborder="0"
         allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
         allowfullscreen>
       </iframe>
       <p>
         <b>Virtual Congressional Briefing: Immigrant Rights Activists Under Attack</b><br/>
         <b>January 13, 2021</b><br/>
         <em>
           On January 13, 2021, the New Sanctuary Coalition, the Immigrant Rights Clinic
           at NYU School of Law, the National Immigrant Justice Center,
           Migrant Justice, and the Immigrant Justice Network
           held a panel discussion with targeted leaders of the immigrant rights movement.
           Clinic students also presented an interactive map highlighting
           the breadth of the government’s campaign to silence immigrant leaders.
           With the Biden Administration soon to take office,
           this moment calls for a public reckoning of our country’s immigration policy.
           Immigrant voices must be protected and centered in this conversation.
           The briefing addressed what members of Congress can do to defend and prevent further
           retaliation against members of the immigrant community.
         </em>
       </p>
      </div>
      <div>
       <iframe
         width="100%"
         height="400px"
         src="https://www.youtube-nocookie.com/embed/atRLK5VkcOg"
         frameborder="0"
         allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
         allowfullscreen>
       </iframe>
       <p>
         <b>Enrique Balcazar</b><br/>
         <b>Detained by ICE in 2017.</b><br/>
         <em>
           “For my community, all over the country, fear is not an option.
           This administration is trying to force us back into the shadows.
           They are intimidating people. They are trying to make police
           collaborate with immigration. It is completely unjust for us.
           So I ask the community: don’t give into fear. Let’s not be afraid.
           Let’s defend our rights. We want to be part of this community all
           over the country and defend our rights always. Let’s not lose faith,
           let’s not lose hope.”
         </em>
       </p>
      </div>
      <div>
       <iframe
         width="100%"
         height="400px"
         src="https://www.youtube.com/embed/WkdBigm98oY"
         frameborder="0"
         allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
         allowfullscreen>
       </iframe>
       <p>
         <b>Rev. Kaji Spellman Douša</b><br/>
         <b>Surveilled and Interrogated by DHS in 2018-19</b><br/>
         <em>
           “My belief, my contention, is that we are being targeted because we expose
           the truth. Because we tell people what we see with our own eyes and we have
           credibility in this, because it’s true...And when people like me speak up,
           this government has decided to retaliate against us...If we want to call
           ourselves free, then we need to be free to serve and free to do the right thing.”
         </em>
       </p>
      </div>
      <div>
       <iframe
         width="100%"
         height="400px"
         src="https://www.youtube-nocookie.com/embed/PeG9ywSCrXM"
         frameborder="0"
         allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
         allowfullscreen>
       </iframe>
       <p>
         <b>Jean Montrevil</b><br/>
         <b>Deported to Haiti in 2018</b><br/>
         <em>
           “I work and stay with my kids. I pay taxes every year.
           I did everything right, everything they have asked me to
           do I have done it. So why do they target me now?”
         </em>
       </p>
      </div>
      <div>
       <iframe
         width="100%"
         height="400px"
         src="https://www.youtube-nocookie.com/embed/xYFjdkY2Kkk"
         frameborder="0"
         allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
         allowfullscreen>
       </iframe>
       <p>
         <b>Alejandra Pablos</b><br/>
         <b>Detained by ICE in 2018.</b><br/>
         <em>
           “It’s been a long time that I’ve been going through this
           case and they’re [ICE] trying to really separate me and tear our
           movement apart, tear our community apart. And I’m not letting that
           happen. I need you to stand up for me, I need you to fight for me...
           They’re [ICE] retaliating against all activists, all organizers,
           people who have advocacy and who are out there fighting, and it’s my
           turn to ask for your help. Please help.”
         </em>
       </p>
      </div>
      <div>
       <iframe
         width="100%"
         height="400px"
         src="https://www.youtube-nocookie.com/embed/dQrddMIJ1n0"
         frameborder="0"
         allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
         allowfullscreen>
       </iframe>
       <p>
         <b>Ravi Ragbir</b><br/>
         <b>Detained by ICE in 2018.</b><br/>
         <em>
           “He [Scott Mechkowski, deputy director of ICE’s New York City field office] said
           that in an affidavit that they [ICE] had war gamed this [Ravi’s detention and
           attempted deportation at his January 11, 2018 check-in]. War gamed this whole
           scenario, this whole series of events. So it wasn’t just that I was coming in
           for a check in - it was a plan to target me and to remove me.”
         </em>
       </p>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue';

export default {
  name: 'Stories',
  components: {
    Header,
  },
};
</script>

<style scoped>
#stories {
  position: absolute;
  top: 86px;
  bottom: 72px;
  left: 0;
  right: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1 fr);
  line-height: 1.35;
}
#stories div {
  border-bottom: 2px solid black;
  padding: 40px;
}
#stories div:nth-child(odd) {
  border-right: 2px solid black;
}
#stories p {
  text-align: left;
}
@media screen and (max-width: 800px){
  #stories { display: block;}
  #stories div { border: 0; }
  #stories div:nth-child(odd) { border: 0; }
}
</style>
